"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Field_1 = __importDefault(require("../../componentReusable/Field"));
const styled_components_1 = require("styled-components");
const AppContextProvider_1 = require("../../contexts/AppContextProvider");
const helpers_1 = require("../../helpers");
const member_1 = require("../../dataLayer/apisWithoutCache/membersApi/member");
const cookiesMember_1 = require("../../dataLayer/cookiesAndLocalStorage/cookiesMember");
const useTrackPageView_1 = __importDefault(require("../../GTMs/useTrackPageView"));
const slrActions_1 = require("../../GTMs/actions/slrActions");
const loggingActions_1 = require("../../libs/logging/helpers/loggingActions");
const ResetPasswordScreen = () => {
    const [error, setError] = (0, react_1.useState)("");
    const [newPassword, setNewPassWord] = (0, react_1.useState)("");
    const [confPassword, setConfPassWord] = (0, react_1.useState)("");
    const { flowState, dispatch } = (0, AppContextProvider_1.useSsoContext)();
    const { translations, isDesktop, isMobile } = (0, styled_components_1.useTheme)();
    (0, useTrackPageView_1.default)("slrResetPassScreen", true, true);
    const onSaveNewPassWord = () => {
        (0, loggingActions_1.authenticateForgotpasswordSubmitAction)();
        const body = {
            Member: {
                phone_number: flowState.phone,
                newPassword: newPassword,
                confirmPassword: confPassword
            },
        };
        (0, member_1.handleUpdateMemberInfo)(body)
            .then((member) => {
            (0, cookiesMember_1.setMemberCookies)(member);
            (0, loggingActions_1.authenticateForgotpasswordSuccessAction)(member.id);
            dispatch({
                screenType: "LOGIN_SUCCESS",
                successScreen: {
                    title: member.success.title,
                    description: member.success.description,
                    withAddPost: true,
                },
                memberData: member
            });
        })
            .catch((e) => setError(e === null || e === void 0 ? void 0 : e.toValidationErrorMsg()));
    };
    const onChangeNewPass = (0, react_1.useCallback)((value) => {
        setNewPassWord(value);
    }, []);
    const onConfirmPass = (0, react_1.useCallback)((value) => {
        setConfPassWord(value);
    }, []);
    const clearNewPass = (0, react_1.useCallback)(() => {
        setNewPassWord("");
    }, []);
    const cleaConfPass = (0, react_1.useCallback)(() => {
        setConfPassWord("");
    }, []);
    (0, react_1.useEffect)(() => {
        if (newPassword.length >= 1 && confPassword.length >= 1) {
            function onKeyup(event) {
                if (event.key === "Enter")
                    onSaveNewPassWord();
                else if (event.code === "Enter")
                    onSaveNewPassWord();
            }
            const keyEventListener = window;
            if (typeof window !== "undefined") {
                keyEventListener.addEventListener("keydown", onKeyup, false);
                return () => keyEventListener.removeEventListener("keydown", onKeyup, false);
            }
        }
    }, [newPassword, confPassword]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "resetPasswordScreen" }, (0, helpers_1.classNames)(isDesktop && "width-460 border radius-8 overflowHidden"), { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)("p-16 whiteBg", isMobile && "pt-0"), { children: [(0, jsx_runtime_1.jsx)("strong", Object.assign({ className: "font-22" }, { children: translations.changePassword })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "font-14 mt-8" }, { children: translations.pleaseFill + " " + translations.newPassword }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "grayBg p-16" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "whiteBg p-16 radius-8 mb-16 fullShadow" }, { children: [(0, jsx_runtime_1.jsx)(Field_1.default, { inputKey: "input-1", type: "password", label: translations.newPassword, error: error["newPassword"], onChangeCb: onChangeNewPass, onClearCb: clearNewPass, value: newPassword, autoFocus: true }), (0, jsx_runtime_1.jsx)(Field_1.default, { inputKey: "input-2", type: "password", label: translations.confirmNewPassword, error: error["confirmPassword"], onChangeCb: onConfirmPass, onClearCb: cleaConfPass, value: confPassword })] })), (0, jsx_runtime_1.jsx)("button", Object.assign({}, (0, helpers_1.classNames)("blueBtn font-17 p-16", ((newPassword === null || newPassword === void 0 ? void 0 : newPassword.length) < 1 || (confPassword === null || confPassword === void 0 ? void 0 : confPassword.length) < 1) && "disabled"), { onClick: () => {
                            onSaveNewPassWord();
                            (0, slrActions_1.gtmNextBtn_SLRResetPassScreen)();
                        } }, { children: translations.save }))] }))] })));
};
exports.default = ResetPasswordScreen;
